import { toast } from 'react-toastify';

import { customActions_universal } from '@redux/actions';
import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/REGISTER') => `${reducer}/${actionType}`;

export const sendOtp = (onOkCB = null) => {
	return async (dispatch, getState) => {
		const { nationalNumber, phone } = getState().organism.register.sendOtp;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.register,
					render: 'checkOtp',
					sendOtp: {
						...getState().organism.register.sendOtp,
						$send: res.data,
					},
				},
			});
			if (onOkCB) onOkCB();
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.register,
					sendOtp: {
						...getState().organism.register.sendOtp,
						_send: status,
					},
				},
			});
		};

		api.$otp_send_register({ onOK, onStatus }, { cellphone: Number(phone), nationalnumber: nationalNumber });
	};
};

export const checkOtp = () => {
	return async (dispatch, getState) => {
		const { phone, nationalNumber, fullName } = getState().organism.register.sendOtp;
		const { otp } = getState().organism.register.checkOtp;

		const onOK = async (res) => {
			const info = {
				...res?.info,
				type: res.info.type ?? 'C',
				token: res.info.token ?? null,
				NAME: fullName,
				PHONE: phone,
				NATIONALNUMBER: nationalNumber,
			};

			await dispatch(customActions_universal.account.login(info));
			toast.success('ثبت نام با موفقیت انجام شد');
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.register,
					checkOtp: {
						...getState().organism.register.checkOtp,
						_check: status,
					},
				},
			});
		};

		api.$otp_check_register(
			{ onOK, onStatus },
			{ phone: Number(phone), code: Number(otp), nationalnumber: nationalNumber, name: fullName },
		);
	};
};

// //CUSTOM ACTION
// await dispatch({
// 	type: generateType('CUSTOM'),
// 	payload: { ...getState().organism.example },
// });
// //SET ACTION
// await dispatch({
// 	type: generateType('SET'),
// 	payload: { scope: '', values: {} },
// });
// //CLEAR ACTION
// await dispatch({
// 	type: generateType('CLEAR'),
// 	payload: { scope: '', values: {} },
// });
